// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"354":"e80ffe6d","668":"e5c6222a","838":"b562eebe"}[chunkId] + ".js";
};